export function objectFitPolyfill(image) {
    if (image && image.currentStyle["object-fit"]) {
        image.style.background = 'url("' + image.src + '") no-repeat 50%/' + image.currentStyle["object-fit"];
        image.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + image.width + "' height='" + image.height + "'%3E%3C/svg%3E";
    }
}